import { render } from "./_3.vue?vue&type=template&id=0c128508&scoped=true"
import script from "./_3.vue?vue&type=script&lang=js"
export * from "./_3.vue?vue&type=script&lang=js"

import "./_3.vue?vue&type=style&index=0&id=0c128508&scoped=true&lang=css"

import exportComponent from "/Users/marianne/DevProjects/Marinka backup 29-08-2025/full website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c128508"]])

export default __exports__